import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { formatPublicReference } from "@/utils/formatReference";
import {
  bookingStatusLabel,
  BOOKING_STATUS_LABELS,
} from "@/utils/statusLabels";
import { formatDate } from "@/utils/formatDate";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminBookings',
  props: {
    bookings: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const route = useRoute();
const search = ref("");
const normalizedSearch = computed(() => search.value.replace(/-/g, ""));
const statusFilter = ref<string | null>((route.query.status as string) || null);

const statusOptions = Object.entries(BOOKING_STATUS_LABELS).map(
  ([value, title]) => ({ title, value })
);

const filteredItems = computed(() => {
  if (!statusFilter.value) return props.bookings;
  return props.bookings.filter((b) => b.status === statusFilter.value);
});

const headers = [
  { title: "Referencia", key: "publicReference" },
  { title: "Cég", key: "companyName" },
  { title: "Felhasználó", key: "userEmail" },
  { title: "Költséghely", key: "costCenterName" },
  { title: "Létrehozva", key: "createdAt" },
  { title: "Módosítva", key: "updatedAt" },
  { title: "Státusz", key: "status" },
  { title: "Részletek", key: "id", align: "end" },
];

const handleViewClick = (id: number) => {
  console.log("View booking", id);
  router.push(`/admin/bookings/${id}`);
};

const __returned__ = { props, route, search, normalizedSearch, statusFilter, statusOptions, filteredItems, headers, handleViewClick, computed, ref, get useRoute() { return useRoute }, get router() { return router }, get formatPublicReference() { return formatPublicReference }, get bookingStatusLabel() { return bookingStatusLabel }, get BOOKING_STATUS_LABELS() { return BOOKING_STATUS_LABELS }, get formatDate() { return formatDate } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})